<template>
    <div>
        <div class="title">
            <h5>
                Let's work together to get you the best mortgage solution.     
            </h5>
        </div>
        <div class="container">
            <form class="signupform" @submit.prevent="submit">
                <div class="row">
                    <div class="col-md-4">
                        <label for="firstname" class="form-label">First name</label>
                        <input type="text" v-model="form.firstname" class="form-control formInput" id="firstname" required>
                    </div>

                    <div class="col-md-4">
                        <label for="lastname" class="form-label">Last name</label>
                        <input type="text" v-model="form.lastname" class="form-control formInput" id="lastname" required>
                    </div>

                    <div class="col-md-4">
                        <label for="email" class="form-label">Email</label>
                        <input type="email" v-model="form.email" class="form-control formInput" id="email"  required>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <label for="phone" class="form-label">Phone Number</label>
                        <input type="tel" v-model="form.phone" class="form-control formInput" id="phone" name="phone" @input="acceptNumber" required>
                    </div>

                    <div class="col-md-6">
                        <label for="city" class="form-label">City</label>
                        <input type="text" v-model="form.city" class="form-control formInput" id="city" name="city" required>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label for="comment" class="form-label">Comment:</label>
                        <textarea class="form-control formInput" v-model="form.comment" id="comment" rows="3"></textarea>
                    </div>
                </div>
                

                <div class="row">
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="checked" required>
                            <label class="form-check-label" >
                                I agree to the <a href="https://www.comsavings.com/privacy">Privacy Policy</a> and give <a href="https://www.comsavings.com/legal/marketing-consent">Marketing Consent.</a>
                            </label>
                        </div>
                    </div>
                </div>

                <p v-if="errors.length">
                    <b>Please correct the following error(s):</b>
                    <ul>
                    <li v-for="(error, index) in errors" :key=index>{{ error }}</li>
                    </ul>
                </p>

                <p v-if="sent">
                    <b class="thankYouReply">Thank you for your information, we will contact you soon!</b>
                </p>


                <div class="col-12 submitButton">
                    <button class="btn btn-primary" type="submit">{{ submitted? "Sending..." : "Submit" }}</button>
                </div>
                
            </form>
        </div>

    </div>
    
</template>

<script>
import {sendInfo} from '../components/api/SendForm.js'
import router from '../router/index.js'

export default {

    data() {
      return {
        errors: [],
        sent: false,
        submitted: false,
        form : {
            email: '',
            firstname: '',
            lastname: '',
            phone: '',
            city: '',
            comment: ''
        }
      }
    },

    methods: {
        async submit() {
            if (this.checkForm())
            {
                this.submitted = true;

                const response = await sendInfo (this.form);
                
                if(response.code === "SUCCESS") {

                    this.sent = true;
                    this.form.email = '';
                    this.form.firstname = '';
                    this.form.lastname = '';
                    this.form.phone = '';
                    this.form.city = '';
                    this.form.comment = '';
                    this.form.checked = false;

                    router.push({ name: 'thankyou'});
                    
                } else {

                    if (response.message === undefined)
                    {
                        this.errors.push('Our server is temporary offline, please try again later');
                    } else {
                        this.errors.push(response.message);
                    }

                    this.submitted = false;
                }

            }
            
        },
        acceptNumber() {
            let x = this.form.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.form.phone = !x[2] ? x[1] :   x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validPhone: function (phone) {
            var re = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
            return re.test(phone);
        },
        checkForm() {
            this.errors = [];

            if (!this.validEmail(this.form.email)) {
                this.errors.push('Valid email required.');
            }

            if (this.form.email === '') {
                this.errors.push('email is required.');
            }

            if (!this.validPhone(this.form.phone)) {
                this.errors.push('valid phone required.');
            } 

            if (!this.errors.length) {
                return true;
            }

            return false;
        }

    }
}
</script>